import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppStore } from "../../store";
import { NotificationActions } from "../../store/notifications/actions";
import { Notification } from "../../store/notifications/models";

export function useGlobalNotifications() {
  const dispatch = useDispatch();
  const { t: errors } = useTranslation("errors");
  const { t: notifications } = useTranslation("notifications");

  const rawNotification = useSelector<AppStore, Notification>(
    (store) => store.notification
  );

  const notification = useMemo(() => {
    return (
      rawNotification && {
        ...rawNotification,
        title:
          rawNotification.variant === "error"
            ? errors(rawNotification.title)
            : notifications(rawNotification.title),
      }
    );
  }, [rawNotification, errors, notifications]);

  const handleClose = useCallback(
    () => dispatch(NotificationActions.clearNotification()),
    [dispatch]
  );

  return { notification, handleClose };
}
